import { apiGatewayService, ApiType } from "services/api/ApiGatewayService";
import { ParameterQuery } from "utils/commonFunctions";

export enum AssetImportJobStatus {
    SUCCEEDED = "SUCCEEDED",
    FAILED = "FAILED",
    STARTED = "STARTED",
    WARNING = "WARNING",
}

export interface AssetImportJob {
    groupUuid: string;
    timestamp: number;
    status: AssetImportJobStatus;
    totalFailedAssets: number;
    totalImportedAssets: number;
    totalRequestedAssets: number;
}

interface AssetImportJobDto {
    group_uuid: string;
    timestamp: number;
    status: AssetImportJobStatus;
    total_failed_assets: number;
    total_imported_assets: number;
    total_requested_assets: number;
}

interface Result {
    jobs: AssetImportJobDto[];
}

function toAssetImportJob(dto: AssetImportJobDto): AssetImportJob {
    return {
        groupUuid: dto.group_uuid,
        timestamp: dto.timestamp,
        status: dto.status,
        totalFailedAssets: dto.total_failed_assets,
        totalImportedAssets: dto.total_imported_assets,
        totalRequestedAssets: dto.total_requested_assets,
    };
}

class AssetImportJobService {
    public fetchJobs(
        groupUuid: string,
        count: number | null,
        abortController?: AbortController
    ): Promise<AssetImportJob[]> {
        const queryString = new ParameterQuery()
            .add("group_uuid", groupUuid)
            .add("count", count?.toString())
            .createQueryString();
        return apiGatewayService
            .invokeApi(`/api/v1/asset-import-jobs${queryString}`, "GET", null, {
                abortSignal: abortController?.signal,
                apiType: ApiType.ARTHUR,
            })
            .then((result: Result) => {
                return result.jobs.map(toAssetImportJob);
            });
    }
}

export const assetImportJobService = new AssetImportJobService();
